import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

const FiltersSkeleton = ({ quantity }) => {
  const skeletons = new Array(quantity).fill('');

  return (
    <Stack gap={2} sx={{ px: 2, py: 3 }}>
      {skeletons.map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Skeleton key={i} variant="rectangular" width="100%">
          <TextField />
        </Skeleton>
      ))}
    </Stack>
  );
};

FiltersSkeleton.propTypes = {
  quantity: PropTypes.number,
};
FiltersSkeleton.defaultProps = {
  quantity: 3,
};

export default FiltersSkeleton;
